import type { FiredAlert } from "../types/alerts";
import { SEVERITY_VARS } from "../lib/themeColors";

interface AlertPanelProps {
  alerts: FiredAlert[];
  onAcknowledge: (id: string) => void;
}

function formatTime(ts: number): string {
  const d = new Date(ts);
  return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", second: "2-digit" });
}

export function AlertPanel({ alerts, onAcknowledge }: AlertPanelProps) {
  if (alerts.length === 0) {
    return (
      <div className="alert-panel">
        <p className="alert-panel__empty">No alerts</p>
      </div>
    );
  }

  return (
    <div className="alert-panel">
      <div className="alert-panel__list">
        {alerts.map((alert) => (
          <div
            key={alert.id}
            className={`alert-panel__item ${alert.acknowledged ? "alert-panel__item--ack" : ""}`}
            onClick={() => onAcknowledge(alert.id)}
          >
            <span
              className="alert-panel__severity"
              style={{ backgroundColor: SEVERITY_VARS[alert.severity as keyof typeof SEVERITY_VARS] || "var(--text-dim)" }}
            >
              {alert.severity.charAt(0).toUpperCase()}
            </span>
            <span className="alert-panel__message">{alert.message}</span>
            <span className="alert-panel__time">{formatTime(alert.timestamp)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
